<script>
export default {
  name: "LeaderRadar"
}
</script>

<template>
  <keep-alive :include="['ErrorList',]">
  <router-view></router-view>
  </keep-alive>
</template>

<style scoped>

</style>